import React, { Component } from 'react'
import { getFormValues, change } from 'redux-form'
import { connect } from 'react-redux'
import { MuiForm } from 'material-ui-elements'
import _ from 'lodash'
import qs from 'query-string'
import axios from 'axios'
import core from '../../core'
import { PATH, FORM } from '../constants'

const {
  constants: { API_URL },
  components: { NoMatch },
  helpers: { isPhone, isEmail, getUserByEmail, auth }
} = core

const { fields } = MuiForm

class Detail extends Component {
  state = {
    anchorEl: null
  }

  handleClick = event => {
    this.setState({ anchorEl: event.currentTarget })
  }

  async componentWillMount() {
    const profile = await getUserByEmail()
    if (this.props.match.params.id === 'new') {
      this.initialDataToState(profile)
      return
    }
    this.fetchToState(profile)
  }

  async fetchToState(profile = null) {
    const { data } = await axios.get(
      `${API_URL}/users/${this.props.match.params.id}`,
      {
        headers: { authorization: auth(true) }
      }
    )

    if (profile) {
      this.setState({ data, profile })
    } else {
      this.setState({ data })
    }
  }

  initialDataToState(profile = null) {
    const data = {
      email: '',
      phone: '',
      isActive: 1,
      role: 'user',
      firstName: '',
      lastName: '',
      notes: '',
      password: ''
    }
    if (profile) {
      this.setState({ data, profile })
    } else {
      this.setState({ data })
    }
  }

  isDisabled(add) {
    return qs.parse(this.props.location.search).view !== 'edit' && !add
  }

  render() {
    const {
      match: { params: { id } },
      history: { push },
      snackbar
    } = this.props

    if (!this.state.data) return null
    const { profile } = this.state

    if (_.isEmpty(this.state.data))
      return <NoMatch style={{ marginTop: 200 }} />

    const add = id === 'new'

    return (
      <div>
        <MuiForm
          open
          name={FORM}
          disabled={this.isDisabled(id === 'new')}
          add={add}
          initialValues={this.state.data}
          title={this.state.data.email || 'Create New User'}
          fields={[
            [
              {
                type: fields.text,
                name: 'email',
                label: 'Email / Login',
                required: true,
                validate: v =>
                  v
                    ? isEmail(v) ? undefined : 'Enter valid email address'
                    : 'Field is required',
                normalize: v => v.toLowerCase()
              },
              {
                type: fields.text,
                name: 'phone',
                label: 'Phone',
                required: true,
                validate: v =>
                  v
                    ? isPhone(v)
                      ? undefined
                      : 'Phone number should have 8 or 9 digit with leading 0'
                    : 'Field is required'
              }
            ],
            [
              {
                type: fields.text,
                name: 'firstName',
                label: 'First Name',
                required: true,
                validate: v => (v ? undefined : 'Field is required')
              },
              {
                type: fields.text,
                name: 'lastName',
                label: 'Last Name',
                required: true,
                validate: v => (v ? undefined : 'Field is required')
              }
            ],
            {
              type: fields.select,
              name: 'isActive',
              label: 'Status',
              required: true,
              // validate: v => (v ? undefined : 'Field is required'),
              // options: [
              //   { value: true, label: 'Active' },
              //   { value: false, label: 'Inactive' }
              // ]
              validate: v =>
                v === 1 || v === 0 ? undefined : 'Field is required',
              options: [
                { value: 1, label: 'Active' },
                { value: 0, label: 'Inactive' }
              ]
            },
            {
              type: fields.select,
              name: 'role',
              label: 'Role',
              required: true,
              validate: v => (v ? undefined : 'Field is required'),
              options:
                profile.role === 'admin'
                  ? [
                      { value: 'user', label: 'User' },
                      { value: 'admin', label: 'Admin' }
                    ]
                  : [
                      { value: 'user', label: 'User' },
                      { value: 'admin', label: 'Admin' },
                      { value: 'superadmin', label: 'SuperAdmin' }
                    ]
            },
            [
              {
                type: fields.password,
                name: 'password',
                required: add,
                label: 'Password',
                hidden: this.isDisabled(add),
                validate: v => {
                  if (add)
                    return v
                      ? /^$|[[A-Za-z\d$@$!%*#?&]{8,}/.test(v)
                        ? undefined
                        : 'Password should have at least 8 characters'
                      : 'Field is required'
                  if (v)
                    return /^$|[[A-Za-z\d$@$!%*#?&]{8,}/.test(v)
                      ? undefined
                      : 'Password should have at least 8 characters'
                  return undefined
                }
              },
              {
                type: fields.password,
                name: 'passwordConfirmed',
                label: 'Confirm password',
                required: add,
                hidden: this.isDisabled(add),
                validate: (v, formValues) => {
                  if (formValues.password && formValues.password !== v) {
                    return 'Provided passwords are different'
                  }
                }
              }
            ]
          ]}
          actions={{
            add: async data => {
              let dataAdjusted = data
              delete dataAdjusted['id']
              await axios.post(`${API_URL}/users/`, dataAdjusted, {
                headers: { authorization: auth(true) }
              })
              push(PATH)
              snackbar(`${data.email} has been added succesfully`)
            },
            edit: () => {
              push(`${PATH}${id}?view=edit`)
            },
            save: async data => {
              let dataAdjusted = data
              delete dataAdjusted['id']
              await axios.put(`${API_URL}${PATH}${id}`, dataAdjusted, {
                headers: { authorization: auth(true) }
              })
              push(PATH)
              snackbar(`${data.email} has been edited succesfully`)
            },
            undo: () => {
              push(`${PATH}${id}`)
            },
            cancel: () => push(PATH)
          }}
        />
      </div>
    )
  }
}

export default connect(
  (state, ownProps) => ({
    role: getFormValues(FORM)(state) ? getFormValues(FORM)(state).role : '',
    password: getFormValues(FORM)(state)
      ? getFormValues(FORM)(state).password
      : ''
  }),
  { change }
)(Detail)

// export default Detail



// WEBPACK FOOTER //
// ./src/users/components/Detail.js